import { render, staticRenderFns } from "./DeleteRfDevice.vue?vue&type=template&id=860b23f0"
import script from "./DeleteRfDevice.vue?vue&type=script&lang=js"
export * from "./DeleteRfDevice.vue?vue&type=script&lang=js"
import style0 from "./DeleteRfDevice.vue?vue&type=style&index=0&id=860b23f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports